<template lang="pug">
div
	v-card.mb-6.pb-2(outlined)
		v-toolbar.white--text(color="primary" flat height="30px")
			v-toolbar-title.body-1.font-weight-bold {{$t('gear-filters.heading')}}
		v-list(nav dense)
			v-list-item-group(multiple)
				v-subheader.font-weight-bold.body-1 {{$t('gear-filters.heading.pricerange')}}
				v-container
					v-range-slider(
					:min="pricerange[0]"
					:max="pricerange[1]"
					color="primary"
					track-color="grey"
					hide-details
					thumb-label
					thumb-size="40"
					@mouseup="onChange"
					v-model="priceRangeFilter")
						template(v-slot:thumb-label="{value}")
							small {{ $n(value, 'currency', $i18n.locale) }}
					.d-flex.justify-space-between(v-if="loaded")
						small.grey--text {{ $n(priceRangeFilter[0], 'currency', $i18n.locale) }}
						small.grey--text {{ $n(priceRangeFilter[1], 'currency', $i18n.locale) }}
			template(v-for="categoryFeature in features" :title="categoryFeature.feature.name")
				v-list-item-group(multiple v-model="filters[categoryFeature.feature.slug]")
					v-subheader.font-weight-bold.body-2 {{categoryFeature.feature.name}}
					list-checkbox(
					v-for="option in categoryFeature.feature.options"
					:value="option.slug"
					:key="option.id"
					:title="option.name"
					@change="onChange"
					:class="getDocCount(categoryFeature.feature, option) === 0 ? 'grey--text': ''")
						| {{option.name}}
						small.grey--text(v-if="loaded")  ({{getDocCount(categoryFeature.feature, option)}})

</template>

<script>
import {
	VListItem,
	VListItemTitle,
	VListItemAction,
	VListItemContent,
	VCheckbox
} from 'vuetify/lib';
import itemsjs from 'itemsjs';

const ListCheckbox = {
	render(createElement) {
		const content = createElement(VListItemContent, [
			createElement(VListItemTitle, this.$slots.default)
		]);
		return createElement(VListItem, {
			style: 'min-height:0',
			attrs: this.$attrs,
			props: { color: 'primary' },
			on: this.$listeners,
			scopedSlots: {
				default: ({ active }) => {
					const checkbox = createElement(
						VListItemAction,
						{ class: 'mr-2 my-0' },
						[
							createElement(VCheckbox, {
								props: {
									inputValue: active,
									trueValue: this.$attrs.value,
									dense: true
								}
							})
						]
					);

					return [checkbox, content];
				}
			}
		});
	}
};

export default {
	components: {
		ListCheckbox
	},
	props: {
		features: {
			type: Array,
			required: true,
			default: () => []
		},
		products: {
			type: Array,
			required: true,
			default: () => []
		}
	},
	data() {
		return {
			filterConfiguration: {},
			priceRangeFilter: [],
			filters: {},
			aggregations: {},
			loaded: false
		};
	},
	computed: {
		pricerange() {
			if (this.products.length === 0) return [0, 100];

			const min = Math.min.apply(
				Math,
				this.products.map(function (o) {
					return o.price;
				})
			);

			const max = Math.max.apply(
				Math,
				this.products.map(function (o) {
					return o.price;
				})
			);

			return [Math.floor(min), Math.ceil(max)];
		},
		flatProducts() {
			if (!this.products.length) return [];

			return this.products.map(product => {
				const newProduct = { ...product, featureTexts: {} };

				product.featureValues
					.filter(featureValue => featureValue)
					.forEach(featureValue => {
						newProduct[featureValue.option.feature.slug] =
							newProduct[featureValue.option.feature.slug] || [];
						newProduct[featureValue.option.feature.slug].push(
							featureValue.option.slug
						);
					});

				return newProduct;
			});
		}
	},
	created() {
		this.features.forEach(categoryFeature => {
			this.filters[categoryFeature.feature.slug] = [];
		});
	},
	mounted() {
		this.priceRangeFilter = this.pricerange;
		this.setFilterConfiguration(this.features);
		this.onChange();
	},
	methods: {
		onChange() {
			this.$nextTick(this.itemsjsResult);
		},
		itemsjsResult() {
			const result = itemsjs(
				this.flatProducts,
				this.filterConfiguration
			).search({
				per_page: 100,
				query: '',
				filters: this.filters,
				filter: product => {
					if (this.priceRangeFilter) {
						return (
							product.price >= this.priceRangeFilter[0] &&
							product.price <= this.priceRangeFilter[1]
						);
					}
					return true;
				}
			});

			this.$emit('filtered-products', result.data.items);
			this.aggregations = result.data.aggregations;

			if (!this.loaded) {
				this.loaded = true;
			}

			return result.data.items;
		},
		getDocCount(feature, option) {
			const docCount = this.aggregations[feature.slug]
				? this.aggregations[feature.slug].buckets.find(
						b => b.key === option.slug
				  )
				: false;
			return docCount ? docCount.doc_count : 0;
		},
		setFilterConfiguration(features = []) {
			const searchableFields = ['rating', 'price'];
			const aggregations = {};

			features.forEach(categoryFeature => {
				searchableFields.push(categoryFeature.feature.slug);
				aggregations[categoryFeature.feature.slug] = {
					title: categoryFeature.feature.name,
					size: 25,
					conjunction: false
				};
			});

			this.filterConfiguration = {
				searchableFields,
				aggregations
			};
		}
	}
};
</script>
